export const expiresInMillisecondsToMinutes = (expiresInMilliseconds: number | undefined): number | undefined => {
  return expiresInMilliseconds && expiresInMilliseconds > 0 ? expiresInMilliseconds / 60 / 1000 : undefined;
};

export const expiresInMillisecondsToMiliSeconds = (expiresInMilliseconds: number | undefined): number | undefined => {
  return expiresInMilliseconds && Number.isInteger(expiresInMilliseconds) && expiresInMilliseconds > 0
    ? expiresInMilliseconds * 60 * 1000
    : undefined;
};
